import { DataContext } from '@philips-internal/oswald-ui-core/lib/component';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { FoundationUtils } from '../../../../utils/foundation-utils';
import { ADEP_E9129Parameters, FunctionName } from '../../../../utils/parameters';
import { GlycemicControl, GlycemicProcess, GlycemicProcessStatus } from './glycemic-types';

export enum GlycemicAction {
  BY_PROCESS = 'text.perform-by-process',
  BY_SCHEDULE = 'text.perform-by-schedule'
}

export enum GlycemicStep {
  QUESTIONS = 'QUESTIONS',
  BARCODE_VALIDATION = 'BARCODE_VALIDATION'
}

export enum GlycemicTypes {
  CONVENTIONAL = 'CONVENTIONAL',
  INTENSIVE = 'INTENSIVE'
}

export const VARIATIONS = [
  {id: 'S', variation: MessageService.translate('text.validation.or-plus')},
  {id: 'E', variation: MessageService.translate('text.validation.or-minus')}
]

class GlycemicUtils {
  public static getPrimaryAction(context: DataContext): GlycemicAction {
    const param13Value = isCheckMedicationBefore();
    const { hasProcess } = context.getBulkData() as GlycemicControl;

    if ((hasProcess) && !param13Value) {
      return GlycemicAction.BY_PROCESS
    }

    return GlycemicAction.BY_SCHEDULE
  }

  private static isProcess(item: GlycemicProcess): boolean {
    return item.processSequence !== null && item.isProcessStatus === GlycemicProcessStatus.PREPARED;
  }

  private static isProcessGenerated(item: GlycemicProcess): boolean {
    return item.processSequence !== null && item.isProcessStatus === GlycemicProcessStatus.GENERATED;
  }

  private static isAnyProcess = (item: GlycemicProcess): boolean => {
    return this.isProcess(item) || this.isProcessGenerated(item);
  }

  public static verifyIfHasProcess(data: GlycemicProcess[]): boolean {
    return data.some(this.isProcess);
  }

  public static verifyIfHasProcessGenerated(data: GlycemicProcess[]): boolean {
    return data.some(this.isProcessGenerated);
  }

  public static filterProcesses(data: GlycemicProcess[]): GlycemicProcess[] {
    return data.filter(this.isAnyProcess)
  }

}

function isCheckMedicationBefore(): boolean {
  const value = FoundationUtils.findModuleParam(FunctionName.ADEP_9129, ADEP_E9129Parameters.CHECK_MEDICATIONS_BEFORE_ADMIN);
  return value === 'S'
}

export default GlycemicUtils;
